// @ts-strict-ignore
export type scrollObserverTypes = {
	nodeId: string
	observerHandler: IntersectionObserverCallback
	rootMargin?: number
	threshold?: number
}

/** Creating an IntersectionObserver instance and observing a target element.
 *
 * @param nodeId - id of observing target element
 * @param observerHandler - callback function
 * @param rootMargin
 * @param threshold
 *
 * */
export const scrollObserver = ({
	nodeId,
	observerHandler,
	rootMargin = 0,
	threshold = 0.1
}: // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
scrollObserverTypes): (() => void) => {
	const observerTarget = document.getElementById(nodeId)

	if (observerTarget) {
		const options: IntersectionObserverInit = {
			rootMargin: `${rootMargin}px`,
			threshold
		}
		const observer = new IntersectionObserver(observerHandler, options)

		observer.observe(observerTarget)

		return () => observer.unobserve(observerTarget)
	}
}
